import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OptionListItemDto } from '../../lib/models/dto/option-list-item-dto';

@Injectable()
export class CaseSetupService {
  constructor(private readonly httpClient: HttpClient) {}

  public getWhereDidUserHearAboutProductOptions(
    propositionId: string,
    interfaceTypeId: string
  ): Observable<Array<OptionListItemDto>> {
    return this.httpClient
      .get<Array<OptionListItemDto>>('/configuration/GetWhereDidYouHearAboutProduct', {
        params: {
          propositionId,
          interfaceTypeId
        }
      })
      .pipe(
        map((optionList) => {
          return optionList.map((option) => new OptionListItemDto().deserialize(option));
        })
      );
  }
}
